import React, { useEffect } from 'react';
import { useParams, Navigate, Outlet } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import { SettingsPageLayout } from './settings-page-layout';
import { PageLoader } from '../../../app/components/page-loader';
import { useCurrentSpace } from '../../../hooks/use-current-space';
import { useAuth } from '../../../workos-auth';

const menu = [
  {
    key: 'general',
    label: 'General',
    href: `../settings/general`,
  },
  {
    key: 'billings',
    label: 'Billing',
    href: `../../settings/billings`,
  },
  {
    key: 'plans',
    label: 'Plans',
    href: `../settings/plans`,
  },
  {
    key: 'users',
    label: 'Users',
    href: `../settings/users`,
  },
  {
    key: 'tags',
    label: 'Tags',
    href: `../settings/tags`,
  },
  {
    key: 'storage',
    label: 'Storage',
    href: `../settings/storage`,
  },
];

export const SpaceSettingsPage: React.FC = observer(() => {
  const { spaceId } = useParams() as { spaceId: string };
  const { role, featureFlags } = useAuth();

  useEffect(() => {
    const isSecurityScreenEnabled = featureFlags.includes('sso');
    const isDeveloperAccessible = featureFlags.includes('developer-tools');

    if (isDeveloperAccessible) {
      menu.push({
        key: 'developers',
        label: 'Developers',
        href: `../settings/developers`,
      });
    }

    if (isSecurityScreenEnabled) {
      menu.push({
        key: 'security',
        label: 'Security',
        href: `../settings/security`,
      });
    }
  }, [featureFlags]);

  if (role === 'guest' || role === 'creator') {
    return <Navigate to={`/space/${spaceId}`} />;
  }

  return (
    <SettingsPageLayout title="Space settings" menu={menu}>
      <Outlet />
    </SettingsPageLayout>
  );
});
